import { DataBean } from "../DataBean";

export class AdquisitionItemByPaa extends DataBean {



    public async getAdquisitionItemByProject(idProject: any, state: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAdquisitionItemByProject_Number_Number_Number_Number", [idProject, state, page, recordsPerPage]);
    }

}